module.exports = ".card {\n    max-width: 600px;\n    margin: 0 auto 0 auto;\n}"